import { tempoApi } from '@/common/api/tempoApi';
import type { ItemTypeLevel } from '@/common/api/types/itemType';

const getItemTypeLevels = async (): Promise<ItemTypeLevel[]> =>
  await tempoApi().get('api/v1/item-store/item-levels').json<ItemTypeLevel[]>();

const getItemTypeLevel = async (params: { levelId: number }): Promise<ItemTypeLevel> =>
  await tempoApi().get(`api/v1/item-store/item-levels/${params.levelId}`).json<ItemTypeLevel>();

const createItemTypeLevel = async (): Promise<ItemTypeLevel> =>
  await tempoApi().post('api/v1/item-store/item-levels').json<ItemTypeLevel>();

const updateItemTypeLevel = async (
  params: { levelId: number },
  payload: { level: number; name: string },
): Promise<ItemTypeLevel> =>
  await tempoApi()
    .put(`api/v1/item-store/item-levels/${params.levelId}`, { json: payload })
    .json<ItemTypeLevel>();

const deleteItemTypeLevel = async (params: { levelId: number }): Promise<void> => {
  await tempoApi().delete(`api/v1/item-store/item-levels/${params.levelId}`);
};

export const ItemTypeLevelApi = {
  getItemTypeLevels,
  getItemTypeLevel,
  createItemTypeLevel,
  updateItemTypeLevel,
  deleteItemTypeLevel,
} as const;
